module.exports = __webpack_public_path__ + "img/logo1.98fb2857.png";